import { create } from 'zustand';
import type { CategorySel, CreatorCategory, CreatorType } from '@/types';

type State = {
  search: string;
  category: CreatorCategory | undefined;
  creator_type: CreatorType | undefined;
  collector: string | undefined;
};

type Actions = {
  setSearch: (v: string) => void;
  setCategorySel: (v: CategorySel | undefined) => void;
  setCollector: (v: string | undefined) => void;
  clearFilters: () => void;
};

const INITIAL: State = {
  search: '',
  category: undefined,
  creator_type: undefined,
  collector: undefined,
};

export const usePipelineFilters = create<State & Actions>((set) => ({
  ...INITIAL,
  setSearch: (v) => set({ search: v }),
  setCategorySel: (v) =>
    set({
      category: v?.category,
      creator_type: v?.type,
    }),
  setCollector: (v) => set({ collector: v }),
  clearFilters: () => set(INITIAL),
}));
